export default "/images/angle-up.svg?e326673a3a17d6d2ca6c5219e25f022f";